import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=a7ed9218"
import script from "./tabs.vue?vue&type=script&lang=js"
export * from "./tabs.vue?vue&type=script&lang=js"
import style0 from "./tabs.vue?vue&type=style&index=0&id=a7ed9218&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7ed9218')) {
      api.createRecord('a7ed9218', component.options)
    } else {
      api.reload('a7ed9218', component.options)
    }
    module.hot.accept("./tabs.vue?vue&type=template&id=a7ed9218", function () {
      api.rerender('a7ed9218', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/tabs.vue"
export default component.exports